import axios from 'axios';

import { Service } from '@app-types/service.type';
import { buildEndpoint, getAuthToken } from '@services/service';

const BASE_SUBSCRIPTIONS_URL = process.env
    .REACT_APP_SUBSCRIPTIONS_URL as string;

const getAllServices = async (): Promise<Service[]> => {
    try {
        const endpoint = buildEndpoint(
            BASE_SUBSCRIPTIONS_URL,
            '/api/admin/services'
        );
        const response = await axios.get(endpoint, {
            headers: { Authorization: getAuthToken() },
        });
        return response.data;
    } catch (err) {
        console.error('Error getting all services:', err);
        return [];
    }
};

export { getAllServices };
